import { withCurrentValueOption } from '../../practice/details/fieldDefinitions';
import {
    resolveOrthodontistFieldOptions,
    type OrthodontistFieldDef
} from './orthodontistCreateFields';
import { OrthodontistFormField } from './OrthodontistFormField';

export interface OrthodontistCreateFieldGridProps {
    fields: OrthodontistFieldDef[];
    values: Record<string, string>;
    fieldError: (key: string) => string | undefined;
    disabled: boolean;
    onFieldChange: (key: string, value: string) => void;
}

export function OrthodontistCreateFieldGrid({
    fields,
    values,
    fieldError,
    disabled,
    onFieldChange
}: OrthodontistCreateFieldGridProps) {
    return (
        <div className="grid grid-cols-12 gap-x-4 gap-y-4 p-5">
            {fields.map((field) => {
                const value = values[field.key] ?? '';
                return (
                    <OrthodontistFormField
                        key={field.key}
                        field={field}
                        value={value}
                        options={withCurrentValueOption(
                            resolveOrthodontistFieldOptions(field),
                            value
                        )}
                        error={fieldError(field.key)}
                        disabled={disabled}
                        onChange={(next) => onFieldChange(field.key, next)}
                    />
                );
            })}
        </div>
    );
}
